import React from 'react';
import {Pressable} from 'react-native';

import Icon, {IconStyle} from './Icon';

type IconProps = {
  disabled?: boolean;
};

const i =
  (iconName: string, iconStyle: IconStyle = 'solid') =>
  ({disabled}: IconProps) => (
    <Icon name={iconName} iconStyle={iconStyle} color={disabled ? '#919191' : undefined} />
  );

type IconButtonProps = IconProps & {
  onPress: () => void;
};

const ib =
  (iconName: string, iconStyle: IconStyle = 'solid') =>
  ({onPress, disabled}: IconButtonProps) => (
    <Pressable onPress={onPress}>{i(iconName, iconStyle)({disabled})}</Pressable>
  );

export const CalendarIcon = i('calendar', 'regular');
export const ContactBookIcon = i('address-book', 'regular');
export const DollarSignIcon = i('dollar-sign', 'solid');
export const EnvelopeIcon = i('envelope', 'regular');
export const PlusIcon = i('plus', 'solid');
export const UserIcon = i('user', 'regular');

export const BarcodeIconButton = ib('barcode', 'solid');
export const CircleXMarkIconButton = ib('circle-xmark', 'solid');
export const SearchIconButton = ib('magnifying-glass', 'solid');
export const TrashIconButton = ib('trash', 'solid');
